import React from "react";
import { Col, Row } from "react-bootstrap";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const AgentCardSkeleton = () => {
  return (
    <Row>
      <Col xs={12} sm={6} md={4} lg={3} xl={2}>
        <div className="skill-card-parent">
          <SkeletonTheme baseColor="#e5e7eb"  duration={1.2}>
            <div className="skill-card" style={{ cursor: "default", pointerEvents: "none" }}>
              <div >
                <Skeleton
                  height={109}
                  width={127}
                  borderRadius={8}
                  style={{ display: "block" }}
                />
              </div>
             
              
            </div>
          </SkeletonTheme>
        </div>
      </Col>
    </Row>
  );
};

export default AgentCardSkeleton;

